import styled from 'styled-components';

export const NewsFeedItemText = styled.div`
  flex: 1 1 0%;
`;
